import React from "react";
import { ReactComponent as BsBoxArrowRight } from "../../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const AllSalaryOutFlowTable = ({ tableData }) => {
  return (
    <div className="AllSalaryOutFlowTable">
      <div className="table-header">
        <ul
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            listStyleType: "none",
          }}
        >
          <li>Receipt id/Time</li>
          <li>Profile</li>
          <li>Total salary (INR)</li>
          <li>Gross salary (INR)</li>
          <li>Dispatched by</li>
          <li>Receipts</li>
        </ul>
      </div>
      <div className="table-body">
        {tableData.map((data, index) => {
          return (
            <ul
              key={data.receiptId}
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(6, 1fr)",
                listStyleType: "none",
                marginTop: "1rem",
              }}
            >
              <li>
                {data.receiptId}
                <br />
                <span
                  style={{ fontSize: "0.8rem", color: "var(--tableColor)" }}
                >
                  {data.time}
                </span>
              </li>
              <li style={{ fontSize: "0.9rem" }}>
                {data.name}({data.position})
                <br />
                <span style={{ color: "var(--blueColor1)" }}>
                  {data.profileId}
                </span>
              </li>
              <li>
                {data.totalSalary}
                <br />
                <span
                  style={{ fontSize: "0.8rem", color: "var(--tableColor)" }}
                >
                  Grade: {data.grade}
                </span>
              </li>
              <li>
                {data.grossSalary}
                <br />
                <span
                  style={{ fontSize: "0.8rem", color: "var(--blueColor1)" }}
                >
                  {data.paymentMode}
                </span>
              </li>
              <li
                style={{
                  color: "var(--successGreen)",
                }}
              >
                {data.dispatchedBy}
              </li>
              <li
                style={{
                  cursor: "pointer",
                  color: "var(--blueColor1)",
                  display: "flex",
                  gap: "0.5rem",
                }}
              >
                Receipts <BsBoxArrowRight />
              </li>
            </ul>
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1rem",
        }}
        className="bottom"
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2rem",
          }}
          className="left"
        >
          <div
            style={{
              backgroundColor: "var(--tableColor)",
              borderColor: "var(--tableColor)",
              color: "#fff",
            }}
            className="number-indicator"
          >
            <span style={{ color: "var(--rawUmber)" }}>Total count:</span>236
          </div>
          <div
            style={{
              color: "var(--tableColor)",
              borderColor: "var(--tableColor)",
              backgroundColor: "var(--tableBackColor)",
            }}
            className="number-indicator"
          >
            <span style={{ color: "var(--rawUmber)" }}>Total salary:</span>₹
            2,60,560
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2rem",
          }}
          className="right"
        >
          <div
            style={{
              borderColor: "var(--blueColor3)",
              color: "var(--blueColor3)",
              backgroundColor: "var(--blueLight1)",
            }}
            className="number-indicator"
          >
            <span style={{ color: "var(--blueLagoon)" }}>Gross Salary:</span>₹
            2,60,560
          </div>
          <div
            style={{
              borderColor: "var(--blueLagoonLight)",
              color: "white",
              backgroundColor: "var(--blueLagoonLight)",
            }}
            className="number-indicator"
          >
            <span style={{ color: "var(--blueLagoon)" }}>Paid Salary:</span>₹
            2,60,560
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllSalaryOutFlowTable;
